import styled, { css } from 'styled-components';
import { StyledAccordion, StyledAccordionContent, StyledAccordionHeader, StyledAccordionTrigger, } from '../../../../accordion/styles/accordion.styled';
import { StyledList, StyledListItem, StyledTypographyListItem } from '../../../../list';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { StyledReceiptGroup } from '../../ReceiptGroup/styles/receipt-group.styled';
export const receiptMainStyles = ({ theme, $colorContext, }) => css `
	padding-bottom: ${pxToRem(theme.spacing[400])};
	background-color: ${$colorContext === 'on-light'
    ? theme.colors.blanc.bgReceipt
    : theme.colors.blanc.bgReceiptOnMedium};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		border-bottom-left-radius: ${pxToRem(theme.borderRadius.m)};
		border-bottom-right-radius: ${pxToRem(theme.borderRadius.m)};
	}

	${StyledList} {
		margin-bottom: 0;
	}

	${StyledListItem}:first-of-type, ${StyledTypographyListItem}:first-of-type {
		padding-top: 0;

		&::before {
			top: 0;
		}
	}

	${StyledAccordionTrigger}, ${StyledAccordionContent} {
		padding-left: 0;
		padding-right: 0;
	}

	${StyledAccordion}, ${StyledAccordionHeader} {
		border-color: ${theme.colors.medium.dividerReceipt};
	}

	${StyledAccordionContent} > ${StyledReceiptGroup}:first-of-type {
		padding-top: 0;
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		${StyledAccordionTrigger} {
			padding-top: ${pxToRem(theme.spacing[400])};
			padding-bottom: ${pxToRem(theme.spacing[400])};
		}
	}
`;
export const StyledReceiptMain = styled.div `
	${receiptMainStyles}
`;
